import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	turnCustomers: [],
	waiting: [],
	viewing: [],
	dismissed: [],
	numDismissed: 0,
	canNegotiatorWorkWithViewingCustomers: false,
	validViewingCustomers: [],
	viewingCustomersSalesCount: 0,
	invalidCustomersCountForMonth: 0,
	// customersAnimatedVisibleCount uses timers to identify nummber of customers 
	// that finished their entry animations, 
	// As it is not recommended to use timers, for animation events
	customersAnimatedVisibleCount: 0,
	// This counter does the same thing, as customersAnimatedVisibleCount but using 
	// onAnimationComplete Api rather than timers, to get a more accuracte 
	// trigger when all customers entry animation is done
	customersEntryAnimationCompleteCount: 0,
	isViewingCustomersEntryAnimationComplete: false, 
	pendingBargainingCount: 0,
	isExtraCustomersButtonVisible: false
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.CUSTOMERS_UPDATE_VIEWING_CUSTOMERS:
		return state.merge({
			viewing: action.viewing
		});
	case types.CUSTOMERS_SET_ANIMATED_VISIBLE_CUSTOMER_COUNT:
		return state.merge({
			customersAnimatedVisibleCount: action.customersAnimatedVisibleCount
		});
	case types.CUSTOMERS_SHOW_EXTRA_CUSTOMERS_BUTTON:
		return state.merge({
			isExtraCustomersButtonVisible: state.waiting.length > 0
		});
	case types.CUSTOMERS_RECEIVED_TURN_CUSTOMERS: 
		return state.merge({
			turnCustomers: action.turnCustomers,
			isExtraCustomersButtonVisible: false
		});
	case types.CUSTOMERS_DISMISS:
		return state.merge({
			viewing: action.viewing,
			numDismissed: action.numDismissed,
			viewingCustomersSalesCount: action.viewingCustomersSalesCount,
			validViewingCustomers: action.validViewingCustomers
		});
	case types.CUSTOMERS_REQUEST_MORE:
		return state.merge({
			viewing: action.viewing,
			isExtraCustomersButtonVisible: false,
			isViewingCustomersEntryAnimationComplete: false,
			customersEntryAnimationCompleteCount: 0,
		});
	case types.CUSTOMERS_PROVIDE_MORE:
		const invalidViewingCustomerCount = state.invalidCustomersCountForMonth
				+ action.invalidViewingCustomersCount;
		return state.merge({
			waiting: action.waiting,
			viewing: action.viewing,
			numDismissed: action.numDismissed,
			validViewingCustomers: action.validViewingCustomers,
			invalidCustomersCountForMonth: invalidViewingCustomerCount,
			isExtraCustomersButtonVisible: false,
			pendingBargainingCount: action.pendingBargainingCount,
			isViewingCustomersEntryAnimationComplete: false,
			customersEntryAnimationCompleteCount: 0,
		});
	case types.CUSTOMERS_FINISH_TURN:
	case types.CUSTOMERS_PREPARE:
		return state.merge({
			waiting: action.waiting,
			viewing: action.viewing,
			numDismissed: action.numDismissed,
			validViewingCustomers: action.validViewingCustomers,
			invalidCustomersCountForMonth: action.invalidViewingCustomersCount,
			isExtraCustomersButtonVisible: false,
			isViewingCustomersEntryAnimationComplete: false,
			customersEntryAnimationCompleteCount: 0,
			
			viewingCustomersSalesCount: 0,
			pendingBargainingCount: action.pendingBargainingCount ?? 0,
		});
	case types.CUSTOMERS_LOAD:
		return state.merge({
			waiting: action.waiting,
			viewing: action.viewing,
			numDismissed: action.numDismissed,
			validViewingCustomers: action.validViewingCustomers,
			invalidCustomersCountForMonth: action.numDismissed + action.invalidViewingCustomersCount,
			viewingCustomersSalesCount: action.soldCustomersCount,
			isExtraCustomersButtonVisible: false,
			isViewingCustomersEntryAnimationComplete: false,
			customersEntryAnimationCompleteCount: 0,
			viewingCustomersSalesCount: 0,
			pendingBargainingCount: action.pendingBargainingCount ?? 0,
		});
	case types.CUSTOMERS_RESET_VALID_VIEWING:
		return state.merge({
			validViewingCustomers: []
		});
	case types.CUSTOMERS_RESET_SALES_FROM_VIEW_COUNT:
		return state.merge({ viewingCustomersSalesCount: 0 });
	case types.CUSTOMERS_ENABLE_NEGOTIATOR_FOR_VIEWING_CUSTOMERS:
		return state.merge({
			canNegotiatorWorkWithViewingCustomers: action.enable,
		});
	case types.CUSTOMERS_ENTRY_ANIMATION_COMPLETE:
		return state.merge({
			isViewingCustomersEntryAnimationComplete: true,
		});
	case types.CUSTOMERS_INCREMENT_ENTRY_ANIMATION_COMPLETE_COUNT:
		const customersEntryAnimationCompleteCount = 
			state.customersEntryAnimationCompleteCount + 1;
		return state.merge({
			customersEntryAnimationCompleteCount,
		});
	case types.CUSTOMERS_DECREMENT_PENDING_BARGAINING_COUNT:
		const pendingBargainingCount = state.pendingBargainingCount - 1;
		return state.merge({
			pendingBargainingCount,
		});
	default:
		return state;
	}
}
